import React from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IProduct, IProductModifier, IProductModifierOption } from 'src/types/products';
import CartProductOption from '../CartProductOption/CartProductOption';

interface IProps {
  product: IProduct;
}

const CartProductModifiers: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  const { product } = props;

  const options: IProductModifierOption[] = product.modifiers.reduce(
    (options: IProductModifierOption[], modifier: IProductModifier) => {
      modifier.options.forEach((option) => {
        if (option.selected) options.push({ ...option, error: modifier.error || option.error });
      });
      return options;
    },
    []
  );

  if (!options.length || !product.modifiers || product.modifiers?.length === 0) return null;

  return (
    <div className="d-flex flex-column">
      <p className="color-gray text-uppercase text-size-12 text-md-size-8 mb-2 family-regular">
        {localeStore.t('modifiers')}
      </p>
      {options.map((option, index) => (
        <CartProductOption key={index} option={option} productQuantity={product.quantity} />
      ))}
    </div>
  );
};

export default React.memo(CartProductModifiers);
